import useViewer from '@vangst/services/oogst/viewer/useViewer'
import { MdNotifications } from 'react-icons/md'
import GroupHeader from '../../components/views/GroupHeader'
import ActivitiesRenderer from '../application/ActivitiesRenderer'

export default function InternalUserDashboardSections() {
  const { viewer } = useViewer()

  return (
    <>
      <section className="flow-y-sm">
        <GroupHeader icon={MdNotifications} title="Alerts"></GroupHeader>
        <div className="max-h-120 overflow-y-auto border border-grey-light p-2 shadow-inner">
          <ActivitiesRenderer
            variables={{
              username: viewer?.username ?? '',
              first: 24,
            }}
            endpoint="getMemberAlerts"
          />
        </div>
      </section>
    </>
  )
}
